<template>
  <div>
    <section class="section--pt-lg">
      <div class="inner">
        <h2 class="Head__blue">
          お気に入りのインストラクター
        </h2>
        <p class="_mg-b15 _l-lg">
          インストラクターをお気に入り登録すると、担当クラスの前日にお知らせが届くようになります。
          <br>お知らせの設定を変える場合は<router-link to="/change/notification/" class="Link__line">
            こちら
          </router-link>
        </p>
        <div
          class="Btn Btn__dotted Btn__dotted--black"
          data-modal-open="class03"
          @click="openModal()"
        >
          インストラクターのプロフィールはこちら
        </div>
        <div class="CheckList__area">
          <div
            v-for="instructor in listInstructors"
            v-show="instructor.display_status == 1"
            :key="instructor.id"
            class="CheckList__box"
          >
            <label
              class="Check__box Check__box__lightblue _ft-spacing60"
            ><input
              v-model="instructor.is_favorite_user"
              type="checkbox"
              name="instructor"
              @click="change(instructor.id)"
            ><span class="Check__box_inner" /><span class="Check__box_inner_tx">{{ instructor.name }}</span></label>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import instructorService from '@/services/instructorService'
import favoriteService from '@/services/favoriteService'
export default {
  name: 'ClassInstructor',
  data() {
    return {
      isOpenInstructor: false,
      listInstructors: {}
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getListInstructors()
    },
    async getListInstructors() {
      const response = await instructorService.index()
      this.listInstructors = response.data
    },
    async change(id) {
      await favoriteService.addInstructorFavorite(id)
      this.$emit('reloadModalIns')
    },
    openModal() {
      this.$emit('modalInstructor')
    }
  }
}
</script>
